import { render, staticRenderFns } from "./MobileFooter.vue?vue&type=template&id=0236849d&scoped=true"
import script from "./MobileFooter.vue.js?vue&type=script&lang=js&external"
export * from "./MobileFooter.vue.js?vue&type=script&lang=js&external"
import style0 from "./MobileFooter.vue?vue&type=style&index=0&id=0236849d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236849d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBottomNavigation,VBtn})
